define.alias("ember-math-helpers/helpers/hypot", "settings/helpers/hypot");